import { useState } from "react";
import { useNavigate } from "react-router-dom";
import adminApi, { setToken } from "../lib/adminApi";
import { KeyRound, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setToken(data.token);
      nav("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-6">
          <div className="grid place-items-center h-10 w-10 rounded-xl bg-indigo-600"><KeyRound className="h-5 w-5 text-white" /></div>
          <div><div className="font-semibold text-zinc-900">Serrurerie 77</div><div className="text-xs text-zinc-500">Espace administration</div></div>
        </div>
        <label className="block text-sm text-zinc-600 mb-1">Email</label>
        <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          className="w-full mb-4 rounded-lg border border-zinc-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
        <label className="block text-sm text-zinc-600 mb-1">Mot de passe</label>
        <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          className="w-full mb-5 rounded-lg border border-zinc-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
        {error && <p data-testid="admin-login-error" className="text-sm text-red-600 mb-4">{error}</p>}
        <button data-testid="admin-login-submit" disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-indigo-600 py-3 font-semibold text-white hover:bg-indigo-700 transition-colors disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Se connecter
        </button>
      </form>
    </div>
  );
}
